import * as Constant from './constant';

export const initialState = { data: [], loading: false, error: false };

const eventReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constant.LIST_EVENT:
      return {
        ...state,
        loading: true,
        data: [],
        error: false,
      };
    case Constant.LIST_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        totalCount: action.payload.total,
        data: action.payload.eventreports,
        error: false,
      };
    case Constant.LIST_EVENT_ERROR:
      return {
        ...state,
        loading: false,
        data: [],
        error: true,
      };

    default:
      return state;
  }
};

export default eventReducer;
